import Vue from 'vue'
import { tenantBillingService } from "../services/tenantBilling.service"

const state = {
  invoices: {},
  loading: false
}

const getters = {
  allInvoices: state => Object.values(state.invoices || {}),

  billingConfiguration: (state, getters, rootState) => {
    const raw = rootState.appState?.systemParameters?.BillingConfiguration;
    
    try { return raw ? JSON.parse(raw) : {}; } 
    catch { return {}; }
  },

  isBillingModuleVisible: (state, getters, rootState) => {
    const user = rootState.user?.user
    if (!user) return false

    if (String(user.type).toLowerCase() !== 'management') return false

    const config = getters.billingConfiguration
    let allowedUserIds = config?.billingVisibleToUserIDs

    if (!Array.isArray(allowedUserIds)) return false
    allowedUserIds = allowedUserIds.map(id => Number(id));
    return allowedUserIds.includes(Number(user.id))
  }
  
}

const actions = {
  async fetchInvoices({ commit }) {
    commit('setLoading', true)
    try {
      const data = await tenantBillingService.fetchInvoices()
      commit('setInvoices', data)
    } catch (err) {
    } finally {
      commit('setLoading', false)
    }
  },

  async downloadInvoice({ commit }, { invoiceId }) {
    await tenantBillingService.downloadInvoice({ invoiceId })
  },

  async fetchInvoiceAttachments({ commit },  { invoiceId }) {
    const attachments = await tenantBillingService.fetchInvoiceAttachments({ invoiceId })
    return attachments
  },

  async downloadAttachment({ commit }, { attachmentId }) {
    await tenantBillingService.downloadAttachment({ attachmentId })
  },

  async getTenantBillingReminderMessage({ commit }) {
    return await tenantBillingService.getTenantBillingReminderMessage();
  },

  
}

const mutations = {
  setInvoices(state, invoices) {
    const map = {}
    for (const inv of (invoices || [])) {
      map[inv.id] = inv
    }
    Vue.set(state, 'invoices', map)
  },

  setLoading(state, loading) {
    Vue.set(state, 'loading', !!loading)
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}